import { render, staticRenderFns } from "./MentoriasLista.vue?vue&type=template&id=84a1db22&"
import script from "./MentoriasLista.vue?vue&type=script&lang=js&"
export * from "./MentoriasLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports